import React from "react";
import { useAppSelector } from "../../../../app/hooks";
import { CURRENCIES_ALLOWED_FOR_VA } from "../../../Wallets/utils";
import VirtualAccountTransactionTable from "../../components/VirtualAccountTransactionTable";
import Account from "../../components/Account";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { FEATURE_FLAG_KEYS } from "../../../../utils/featureFlags";

export default function AllVirtualAccounts() {

  const { wallets } = useAppSelector((state) => state?.wallets);
  const enableVirtualAccountsV2 = useFeatureFlagEnabled(FEATURE_FLAG_KEYS.virtualAccountsV2);

  const virtualAccountPageWallets = wallets?.filter((wallet) => CURRENCIES_ALLOWED_FOR_VA.includes(wallet.currency) && wallet.currency !== 'KES' && (enableVirtualAccountsV2 || wallet.currency !== 'GHS'))

  const pageTitle = "Virtual account balance";
  const tooltipText = "This balance will be automatically swept to your settlement balance at 1:00AM daily.";

  return (
    <section>
      <Account
        title={pageTitle}
        tooltipText={tooltipText}
        baseUrlForRedirection="virtual-account"
        wallets={virtualAccountPageWallets}
      />

      <VirtualAccountTransactionTable />
    </section>
  )
}